<template>
  <div class="inventory-page">
    <!-- 添加悬浮标题栏 -->
    <!-- <div class="floating-header" :class="{ 'show': showFloatingHeader }">
      <div class="floating-header-container">
        <v-table class="inventory-table header-only">
          <thead>
            <tr>
              <th v-for="header in headers" :key="header.key" :class="['text-' + header.align]" :style="{ width: header.width }">
                {{ header.title }}
              </th>
            </tr>
          </thead>
        </v-table>
      </div>
    </div> -->
    
    <div class="inventory-container">
      <!-- 搜索区域 -->
      <v-card class="search-card">
        <v-card-text>
          <v-row class="justify-center">
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="searchForm.keyword"
                persistent-placeholder
                label="搜索货品编号/名称"
                prepend-inner-icon="mdi-magnify"
                variant="outlined"
                hide-details
                density="compact"
                clearable
                class="search-input"
                style="max-width: 300px;"
                @keyup.enter="handleSearch"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                v-model="searchForm.inventoryNo"
                :items="formattedCategoryList"
                item-title="displayName"
                item-value="categoryNo"
                label="库存编码"
                variant="outlined"
                hide-details
                density="compact"
                clearable
                class="search-input"
                :menu-props="{
                  maxHeight: 400,
                  openOnClick: false
                }"
                :return-object="false"
                :filter="filterCategory"
                style="max-width: 300px;"
                @click:clear="handleSearch"
              />
            </v-col>
            <!-- :items="formattedWarehouseList" -->
            <!-- warehouseListOptions -->
            <v-col cols="12" sm="4">
              <!-- <v-autocomplete
                v-model="searchForm.warehouseNo"
                :items="formattedWarehouseList"
                item-title="warehouseName"
                item-value="warehouseNo"
                label="选择仓库"
                variant="outlined"
                hide-details
                density="compact"
                clearable
                class="search-input"
                :filter="customFilter"
                :menu-props="{ maxHeight: 400 }"
                style="max-width: 300px;"
                @click:clear="handleSearch"
              /> -->
              <v-select
                v-model="searchForm.warehouseNo"
                :items="formattedWarehouseList"
                item-title="warehouseName"
                item-value="warehouseNo"
                label="选择仓库"
                placeholder="请选择仓库"
                persistent-placeholder
                variant="outlined"
                density="compact"
                hide-details="auto"
                clearable
                @click:clear="handleSearch"
                return-object
                style="max-width: 300px;"
              >
                <template v-slot:item="{ props, item }">
                  <v-list-item
                    v-bind="props"
                    :title="item.raw.warehouseName"
                    :subtitle="item.raw.warehouseNo ? `地址: ${item.raw.warehouseAddress}` : ''"
                  />
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" sm="4">
              <!-- 使用原生 HTML5 日期输入框，但使用 Vuetify 样式 -->
              <div class="native-date-wrapper" style="max-width: 300px;">
                <v-text-field
                  v-model="searchForm.beginDate"
                  label="开始日期"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  class="native-date-field"
                  @click="openStartDatePicker"
                />
                <!-- 隐藏的原生日期输入框 -->
                <input
                  ref="startDateInput"
                  type="date"
                  v-model="searchForm.beginDate"
                  :max="searchForm.endDate"
                  style="position: absolute; opacity: 0; pointer-events: none;"
                  @change="onStartDateChange"
                />
              </div>
            </v-col>
            <!-- <v-col cols="12" sm="1" class="d-flex align-center justify-center">
              <span class="text-white">至</span>
            </v-col> -->
            <v-col cols="12" sm="4">
              <!-- 使用原生 HTML5 日期输入框，但使用 Vuetify 样式 -->
              <div class="native-date-wrapper" style="max-width: 300px;">
                <v-text-field
                  v-model="searchForm.endDate"
                  label="结束日期"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  class="native-date-field"
                  @click="openEndDatePicker"
                />
                <!-- 隐藏的原生日期输入框 -->
                <input
                  ref="endDateInput"
                  type="date"
                  v-model="searchForm.endDate"
                  :min="searchForm.beginDate"
                  style="position: absolute; opacity: 0; pointer-events: none;"
                  @change="onEndDateChange"
                />
              </div>
            </v-col>
            <!-- <v-col cols="12" sm="4">
              <date-input
                v-model="searchForm.beginDate"
                placeholder="开始日期"
                class="search-input"
                style="max-width: 300px;"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <date-input
                v-model="searchForm.endDate"
                placeholder="结束日期"
                class="search-input"
                style="max-width: 300px;"
              />
            </v-col> -->
            <v-col cols="12" sm="4" class="d-flex align-center">
              <div style="width: 100%; padding-right: calc(50% - 84px); margin-left: auto; display: flex; gap: 8px;">
                <v-btn
                  color="primary"
                  variant="flat"
                  @click="handleSearch"
                  class="search-btn"
                  density="compact"
                  style="width: 80px; height: 32px;"
                >
                  查询
                </v-btn>
                <v-btn
                  color="primary"
                  variant="flat"
                  @click="handleReset"
                  class="search-btn"
                  density="compact"
                  style="width: 80px; height: 32px;"
                >
                  重置
                </v-btn>
                <v-btn
                  color="primary"
                  variant="flat"
                  prepend-icon="mdi-file-excel"
                  @click="exportToExcel"
                  class="search-btn"
                  density="compact"
                  style="width: 80px; height: 32px;"
                >
                  导出
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 表格区域 -->
      <v-card class="table-card">
        <v-card-text class="pa-0">
          <v-table class="inventory-table all-big-table" hover fixed-header>
            <thead>
              <tr>
                <th v-for="header in headers" :key="header.key" :class="['text-' + header.align]" :style="{ width: header.width }">
                  {{ header.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading" class="text-center">
                <td :colspan="headers.length" class="py-8">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <div class="mt-2">加载中...</div>
                </td>
              </tr>
              <tr v-else-if="goodsList.length === 0" class="text-center">
                <td :colspan="headers.length" class="py-8">暂无数据</td>
              </tr>
              <template v-else>
                <template v-for="(item, index) in goodsList" :key="index">
                  <!-- 主行 - 每个货品只显示一行基本信息 -->
                  <tr class="main-row">
                    <td class="text-start" data-key="goodsNo">
                      <template v-if="item.isVirtualNo !== 1">
                        {{ item.goodsNo || '-' }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <td class="text-start" data-key="goodsName">{{ item.goodsName || '-' }}</td>
                    <td class="text-start" data-key="goodsSpec">{{ item.goodsSpec || '-' }}</td>
                    <td class="text-start" data-key="goodsDesc">{{ item.goodsDesc || '-' }}</td>
                    <td class="text-start" data-key="inventoryName">{{ item.inventoryName || '-' }}</td>
                    <!-- 有多个仓库时，主行仓库字段显示"多个仓库"标签 -->
                    <!-- <td>仓库</td> -->
                    <td v-if="!item.warehouseInventories || item.warehouseInventories.length <= 1" class="text-start" data-key="warehouseName">
                      {{ item.warehouseInventories && item.warehouseInventories.length === 1 ? 
                         `${item.warehouseInventories[0].warehouseName}` : '-' }}
                    </td>
                    <td v-else class="text-start" data-key="warehouseName">
                      多个仓库
                    </td>
                    
                    <!-- 根据时间选择状态显示不同的列 -->
                    <template v-if="!searchForm.beginDate && !searchForm.endDate">
                      <!-- 没有选择时间，显示待领用、采购中、库存列 -->
                      <!-- <td class="text-end" data-key="pendingQuantity">{{ formatNumber(item.pendingQuantity) }}</td> -->
                      <td class="text-end" data-key="materialEstimateQuantity">{{ formatNumber(item.bomEstimateQuantity) }}
                        <template v-if="item.bomEstimateQuantity">{{ item.bomEstimateQuantityUnit }}</template>
                      </td>
                      <td class="text-end" data-key="purchaseQuantity">{{ formatNumber(item.purchasingQuantity) }}
                        <template v-if="item.purchasingQuantity">{{ item.unit }}</template>
                      </td>
                      <td class="text-end" data-key="totalInventoryQuantity">{{ formatNumber(item.totalInventoryQuantity) }}
                        <template v-if="item.totalInventoryQuantity">{{ item.unit }}</template>
                      </td>
                    </template>
                    <template v-else>
                      <!-- 有时间选择，显示期初、入库、出库、期末列 -->
                      <td class="text-end" data-key="totalInitialQuantity">{{ formatNumber(item.totalInitialQuantity) }}</td>
                      <td class="text-end" data-key="totalCurrentInQuantity">{{ formatNumber(item.totalCurrentInQuantity) }}</td>
                      <td class="text-end" data-key="totalCurrentOutQuantity">{{ formatNumber(item.totalCurrentOutQuantity) }}</td>
                      <td class="text-end" data-key="totalEndQuantity">{{ formatNumber(item.totalEndQuantity) }}</td>
                    </template>
                    
                    <!-- <td class="text-center" data-key="unit">{{ item.unit || '-' }}</td> -->
                    <td class="text-center" data-key="actions">
                      <v-btn
                        v-if="showActions" 
                        color="primary"
                        size="small"
                        variant="flat"
                        class="mr-2"
                        @click="handleEdit(item)"
                      >
                        编辑
                      </v-btn>
                      <!-- <v-btn
                        color="primary"
                        size="small"
                        variant="flat"
                        class="mr-2"
                        @click="handleCreatePurchase(item)"
                      >
                        发起采购
                      </v-btn> -->
                      <v-btn
                        color="primary"
                        size="small"
                        variant="flat"
                        class="mr-2"
                        @click="handleCreatePurchaseOrder(item)"
                      >
                        发起请购
                      </v-btn>
                    </td>
                  </tr>
                  
                  <!-- 仓库明细行 - 只有多个仓库时才显示 -->
                  <template v-if="item.warehouseInventories && item.warehouseInventories.length > 1">
                    <tr v-for="(warehouse, wIndex) in item.warehouseInventories" :key="`${item.goodsNo}-${warehouse.warehouseNo}-${wIndex}`" class="warehouse-row">
                      <!-- 非仓库相关字段显示为占位符 -->
                      <td class="text-start warehouse-detail-cell" data-key="goodsNo">-</td>
                      <td class="text-start warehouse-detail-cell" data-key="goodsName">-</td>
                      <td class="text-start warehouse-detail-cell" data-key="goodsSpec">-</td>
                      <td class="text-start warehouse-detail-cell" data-key="goodsDesc">-</td>
                      <td class="text-start warehouse-detail-cell" data-key="inventoryName">-</td>
                      <!-- 仓库信息显示仓库编号和名称 -->
                      <td class="text-start" data-key="warehouseName">
                        {{ warehouse.warehouseName }}
                      </td>
                      
                      <!-- 根据时间选择状态显示不同的列 -->
                      <template v-if="!searchForm.beginDate && !searchForm.endDate">
                        <!-- 没有选择时间，显示待领用、采购中、库存列 -->
                        <!-- <td class="text-end warehouse-detail-cell" data-key="pendingQuantity">-</td> -->
                        <td class="text-end warehouse-detail-cell" data-key="materialEstimateQuantity">
                          <template v-if="warehouse.bomEstimateQuantity">{{ formatNumber(warehouse.bomEstimateQuantity) }}{{ warehouse.bomEstimateQuantityUnit }}</template>
                          <template v-else>-</template>
                        </td>
                        <td class="text-end warehouse-detail-cell" data-key="purchaseQuantity">
                          <template v-if="warehouse.purchasingQuantity">{{ warehouse.purchasingQuantity }}{{ item.unit }}</template>
                          <template v-else>-</template>
                        </td>
                        <td class="text-end font-weight-bold" data-key="totalInventoryQuantity">{{ formatNumber(warehouse.inventoryQuantity) }} <template v-if="warehouse.inventoryQuantity">{{ item.unit }}</template></td>
                      </template>
                      <template v-else>
                        <!-- 有时间选择，显示期初、入库、出库、期末列 -->
                        <td class="text-end font-weight-bold" data-key="totalInitialQuantity">{{ formatNumber(warehouse.initialQuantity) }}</td>
                        <td class="text-end font-weight-bold" data-key="totalCurrentInQuantity">{{ formatNumber(warehouse.currentInQuantity) }}</td>
                        <td class="text-end font-weight-bold" data-key="totalCurrentOutQuantity">{{ formatNumber(warehouse.currentOutQuantity) }}</td>
                        <td class="text-end font-weight-bold" data-key="totalEndQuantity">{{ formatNumber(warehouse.endQuantity) }}</td>
                      </template>

                      <td></td>
                      <!-- <td class="text-center warehouse-detail-cell" data-key="unit">{{ item.unit || '-' }}</td>
                      <td v-if="showActions" class="text-center warehouse-detail-cell" data-key="actions">-</td> -->
                    </tr>
                  </template>
                </template>
              </template>
            </tbody>
          </v-table>

          <!-- 分页区域 -->
          <div class="custom-pagination d-flex align-center justify-space-between">
            <div class="pagination-info">共 {{ total }} 条记录</div>
            
            <div class="d-flex align-center">
              <!-- <span class="items-per-page-text mr-2">每页项目数</span> -->
              <!-- <v-select
                v-model="pageSize"
                :items="[30, 50, 100]"
                variant="outlined"
                density="compact"
                class="d-inline-flex page-size-select mr-4"
                style="width: 80px;"
                hide-details
                @update:model-value="handlePageSizeChange"
              ></v-select> -->
              
              <v-btn
                icon="mdi-page-first"
                size="small"
                variant="text"
                :disabled="currentPage <= 1 || loading"
                @click="changePage(1)"
                class="pagination-btn"
              ></v-btn>
              
              <v-btn
                icon="mdi-chevron-left"
                size="small"
                variant="text"
                :disabled="currentPage <= 1 || loading"
                @click="changePage(currentPage - 1)"
                class="pagination-btn"
              ></v-btn>
              
              <div class="pagination-text mx-4">{{ currentPage }} / {{ totalPages }}</div>
              
              <v-btn
                icon="mdi-chevron-right"
                size="small"
                variant="text"
                :disabled="currentPage >= totalPages || loading"
                @click="changePage(currentPage + 1)"
                class="pagination-btn"
              ></v-btn>
              
              <v-btn
                icon="mdi-page-last"
                size="small"
                variant="text"
                :disabled="currentPage >= totalPages || loading"
                @click="changePage(totalPages)"
                class="pagination-btn"
              ></v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <!-- 导出加载中弹窗 -->
    <v-dialog v-model="exportLoading" persistent max-width="400">
      <v-card color="#2B2D33">
        <v-card-text class="pa-6 text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <div class="text-h6 text-white mb-2">正在准备导出数据</div>
          <div class="text-subtitle-1 text-grey">请稍候...</div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- 导出结果弹窗 -->
    <v-dialog v-model="exportResultDialog" max-width="400">
      <v-card color="#2B2D33">
        <v-card-title class="text-white">{{ exportResultTitle }}</v-card-title>
        <v-card-text class="text-white">{{ exportResultMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="flat" @click="exportResultDialog = false">
            确认
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 发起采购对话框 -->
    <v-dialog
      v-model="showPurchaseDialog"
      max-width="1000"
      height="80vh"
      persistent
    >
      <v-card class="purchase-dialog">
        <v-card-title class="d-flex justify-space-between align-center">
          <span>{{ purchaseData.purchaseOrderNo ? '修改采购' : '发起采购' }}</span>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click="closePurchaseDialog"
          />
        </v-card-title>
        <v-card-text>
          <v-form ref="purchaseForm" v-model="purchaseValid">
            <!-- 供应商选择 -->
            <v-row>
              <v-col cols="8">
                <v-autocomplete
                  v-model="purchaseData.vendor"
                  v-model:search="vendorSearchText"
                  :items="vendorSearchText ? vendorList : []"
                  :loading="vendorLoading"
                  item-title="companyName"
                  item-value="id"
                  label="供应商"
                  placeholder="请输入供应商名搜索"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :no-data-text="vendorSearchText ? '没有找到匹配的供应商' : '请输入供应商名进行搜索'"
                  clearable
                  return-object
                >
                  <template v-slot:item="{ props, item }">
                    <v-list-item
                      v-bind="props"
                      :title="item.raw.companyName"
                      :subtitle="item.raw.type ? `${item.raw.type}` : ''"
                    />
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="purchaseData.warehouse"
                  :items="warehouseList"
                  item-title="warehouseName"
                  item-value="warehouseNo"
                  label="入库仓库"
                  placeholder="请选择入库仓库"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  clearable
                  return-object
                >
                  <template v-slot:item="{ props, item }">
                    <v-list-item
                      v-bind="props"
                      :title="item.raw.warehouseName"
                      :subtitle="item.raw.warehouseNo ? `编号: ${item.raw.warehouseNo}` : ''"
                    />
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <!-- 付款信息 -->
            <v-row class="mt-4">
              <v-col cols="4">
                <v-select
                  v-model="purchaseData.paymentMethod"
                  :items="paymentMethods"
                  label="付款方式"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  item-title="label"
                  item-value="value"
                />
              </v-col>
              <v-col cols="4">
                <div style="position: relative;">
                  <v-text-field
                    v-model="purchaseData.paymentDate"
                    label="计划交货"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    class="native-date-field"
                    @click="openNativeDatePicker"
                  />
                  <!-- 隐藏的原生日期输入框 -->
                  <input
                    ref="nativeDateInput"
                    type="date"
                    v-model="purchaseData.paymentDate"
                    style="position: absolute; left: 0; top: 100%; opacity: 0; pointer-events: none; width: 100%; height: 1px; z-index: 9999;"
                    @change="onNativeDateChange"
                  />
                </div>
              </v-col>
              <v-col cols="4">
                <v-text-field 
                  label="采购单总额"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  :model-value="purchaseData.totalAmount"
                  type="number"
                  class="v-field--readonly"
                  readonly
                >
                  <!-- <template v-slot:append-inner>
                    <span>元</span>
                  </template> -->
                </v-text-field>
              </v-col>
            </v-row>
            <!-- 物料列表 -->
            <div style="color: #fff; font-size: 16px; font-weight: bold; margin-top: 10px;">物料</div>
            <div class="material-purchase-list">
              <div class="material-purchase-body">
                <div 
                  v-for="(material,index) in selectedMaterialDetails" 
                  :key="material.id"
                  class="material-purchase-item"
                >
                  <div class="item-content" style="width: 20%;">
                    <div class="material-name" style="text-align: left;">{{ material.materialName }}</div>
                    <div style="text-align: left;">{{ material.specDesc }}</div>
                    <div class="material-code" style="text-align: left;">{{ material.materialCode }}</div>
                  </div>
                  <!-- <div class="item-content" style="width: 15%;">
                    <v-textarea
                      v-model="material.brand"
                      label="品牌"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      rows="1"
                      resize
                      auto-grow
                      class="auto-grow-textarea"
                    ></v-textarea>
                  </div> -->
                  <div class="item-content" style="width: 10%;">
                    <v-text-field
                      v-model="material.materialCount"
                      label="数量"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      type="number"
                      @input="handleQuantityInput(material,index)"
                    >
                      <!-- <template v-slot:append-inner>
                        <span>{{ material.materialUnit }}</span>
                      </template> -->
                    </v-text-field>
                  </div>
                  <div class="item-content" style="width: 10%;">
                    <v-text-field
                      v-model="material.materialPrice"
                      label="单价"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details
                      type="number"
                      @input="handlePriceInput(material,index)"
                    />
                  </div>
                  <div class="item-content" style="width: 10%;">
                    <v-text-field
                      v-model="material.materialUnit"
                      label="单位"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details
                      type="text"
                    />
                  </div>
                  <div class="item-content" style="width: 10%;">
                    <v-text-field
                      :model-value="calculateTotalPrice(material.materialPrice, material.materialCount)"
                      label="总金额"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      type="number"
                      class="v-field--readonly"
                      readonly
                    />
                  </div>
                  <div class="item-content" style="width: 20%;">
                    <v-textarea
                      v-model="material.remark"
                      label="采购备注"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details
                      rows="1"
                      resize
                      auto-grow
                    ></v-textarea>
                  </div>
                </div>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            color="error"
            variant="tonal"
            @click="closePurchaseDialog"
          >
            取消
          </v-btn>
          <v-btn
            color="primary"
            variant="flat"
            @click="submitPurchase"
            :loading="purchaseLoading"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- 发起请购对话框 -->
    <v-dialog
      v-model="showPurchaseOrderDialog"
      max-width="1200"
      height="45vh"
      persistent
    >
      <v-card class="purchase-dialog">
        <v-card-title class="d-flex justify-space-between align-center">
          <span>{{ purchaseOrderData.id ? '修改请购' : '发起请购' }}</span>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click="closePurchaseOrderDialog"
          />
        </v-card-title>
        <v-card-text>
          <v-form ref="purchaseOrderForm" v-model="purchaseOrderValid">
            <!-- 物料列表 -->
            <div class="material-purchase-list">
              <!-- 表头 -->
              <!-- <div class="material-purchase-header">
                <div class="header-item" style="width: 15%;">物料信息</div>
                <div class="header-item" style="width: 10%;">品牌</div>
                <div class="header-item" style="width: 8%;">数量 <span class="required-mark">*</span></div>
                <div class="header-item" style="width: 8%;">单位</div>
                <div class="header-item" style="width: 20%;">采购备注</div>
                <div class="header-item" style="width: 20%;">入库仓库 <span class="required-mark">*</span></div>
                <div class="header-item" style="width: 19%;">计划交货 <span class="required-mark">*</span></div>
              </div> -->
              <div class="material-purchase-body">
                <div 
                  v-for="(material, index) in purchaseOrderMaterials" 
                  :key="material.id || index"
                  class="material-purchase-item"
                >
                  <div class="item-content" style="width: 12%;">
                    <div class="material-name" style="text-align: left;">{{ material.materialName }}</div>
                    <div class="material-spec" style="text-align: left;">{{ material.specDesc }}</div>
                    <div class="material-code" style="text-align: left;">{{ material.materialCode }}</div>
                  </div>
                  <div class="item-content" style="width: 14%;">
                    <v-text-field v-model="purchaseOrderData.contractNo" label="合同号" persistent-placeholder variant="outlined" density="compact" hide-details />
                  </div>
                  <!-- <div class="item-content" style="width: 8%;">
                    <v-textarea
                      v-model="material.brand"
                      label="品牌"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      rows="1"
                      resize
                      auto-grow
                      class="auto-grow-textarea"
                    ></v-textarea>
                  </div> -->
                  <!-- :rules="[v => !!v || '必填', v => v > 0 || '须大于0']" -->
                  <div class="item-content" style="width: 11%;">
                    <v-text-field
                      v-model="material.materialCount"
                      label="数量"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      type="number"
                      @input="handlePurchaseOrderQuantityInput(material, index)"
                    />
                  </div>
                  <div class="item-content" style="width: 90px;">
                    <v-text-field
                      v-model="material.materialUnit"
                      label="单位"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details
                      type="text"
                      class="v-field--readonly"
                      readonly
                    />
                  </div>
                  <div class="item-content" style="width: 27%;">
                    <v-textarea
                      v-model="material.remark"
                      label="物料备注"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details
                      rows="1"
                      resize
                      auto-grow
                    ></v-textarea>
                  </div>
                  <!-- :rules="[v => !!v?.warehouseNo || '请选择仓库']"
                      :items="warehouseListOptions"
                    -->
                  <div class="item-content" style="width: 15%;">
                    <v-select
                      v-model="material.warehouse"
                      :items="formattedWarehouseList"
                      item-title="warehouseName"
                      item-value="warehouseNo"
                      label="收货仓库"
                      placeholder="请选择收货仓库"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      return-object
                    >
                      <template v-slot:item="{ props, item }">
                        <v-list-item
                          v-bind="props"
                          :title="item.raw.warehouseName"
                          :subtitle="item.raw.warehouseNo ? `地址: ${item.raw.warehouseAddress}` : ''"
                        />
                      </template>
                    </v-select>
                  </div>
                  <div class="item-content" style="width: 15%; position: relative;">
                    <v-text-field
                      v-model="material.paymentDate"
                      label="计划交货"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      class="native-date-field"
                      @click="openMaterialDatePicker(index)"
                    />
                    <!-- 隐藏的原生日期输入框 
                      :rules="[v => !!v || '请选择日期']"-->
                    <input
                      :ref="el => setMaterialDateInputRef(el, index)"
                      type="date"
                      :value="material.paymentDate"
                      :min="getTodayDate()"
                      style="position: absolute; left: 0; top: 100%; opacity: 0; pointer-events: none; width: 100%; height: 1px; z-index: 9999;"
                      @change="(e) => onMaterialDateChange(e, index)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            color="error"
            variant="tonal"
            @click="closePurchaseOrderDialog"
          >
            取消
          </v-btn>
          <v-btn
            color="primary"
            variant="flat"
            @click="submitPurchaseOrder"
            :loading="purchaseOrderLoading"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, reactive, watch, computed, onBeforeUnmount } from 'vue'
import { goodsManageApi, inventoryApi, purchaseApi } from '@/services/api'
import type { 
  GoodsItem, 
  WarehouseItem, 
  CategoryItem, 
  GoodsListQuery,
  MergedGoodsItem,
  MergedGoodsListQuery,
  WarehouseInventory
} from '@/services/api'
import { formatDate } from '@/utils/dateUtils'
import DateInput from '@/components/DateInput.vue'
import { useSnackbar } from '@/composables/useSnackbar'

const { showSuccess, showError } = useSnackbar()

// 搜索表单数据
const searchForm = reactive({
  keyword: '',          // 货品编码或名称
  warehouseNo: '',      // 仓库编号
  inventoryNo: '',      // 库存编码
  inventoryName: '',    // 库存名称
  beginDate: '',        // 开始日期，默认为空
  endDate: ''           // 结束日期，默认为空
})

interface WarehouseItemOptions {
  warehouseNo: string
  warehouseName: string
}

// 表格数据
const goodsList = ref<MergedGoodsItem[]>([])
const warehouseList = ref<WarehouseItem[]>([])
const warehouseListOptions = ref<WarehouseItemOptions[]>([
  { warehouseNo: '上海市闵行区北翟路1630弄51号', warehouseName: '三厂203' },
  { warehouseNo: '江苏省昆山市盛晞路48号', warehouseName: '昆山一厂' },
  { warehouseNo: '江苏省昆山市盛晞路28号', warehouseName: '昆山二厂' },
  { warehouseNo: '江苏省苏州市昆山市昆山开发区三巷路108号', warehouseName: '三号厂房' },
  { warehouseNo: '', warehouseName: '无需收货' }
])

const categoryList = ref<CategoryItem[]>([])  // 所有分类列表
const formattedCategoryList = ref<Array<CategoryItem & { displayName: string; level: number; parentNo?: string }>>([]) // 格式化后的分类列表
const loading = ref(false)
const total = ref(0)
const currentPage = ref(1)
const pageSize = ref(30)
const showActions = ref(false) // 控制操作列的显示隐藏

// 请购弹窗相关变量
const showPurchaseOrderDialog = ref(false)
// 采购弹窗相关变量
const showPurchaseDialog = ref(false)
const selectedMaterialDetails = ref<any[]>([])  // 选中物料的详细信息列表
const purchaseForm = ref()
const purchaseValid = ref(false)
const purchaseLoading = ref(false)
const vendorList = ref<any[]>([])
const vendorLoading = ref(false)
const vendorSearchText = ref('')
const purchaseData = ref({
  vendor: null as any,
  quantity: null as number | null,
  price: null as number | null,
  purchaseOrderNo: null as string | null,
  paymentMethod: {value: '0', label: '预付'},
  paymentDate: null as string | null,
  id: null as number | null,
  totalAmount: 0,
  warehouse: {warehouseNo: '', warehouseName: ''} as any,
})

// 请购弹窗相关变量
const purchaseOrderForm = ref()
const purchaseOrderValid = ref(false)
const purchaseOrderLoading = ref(false)
const purchaseOrderMaterials = ref<any[]>([])  // 请购物料列表
const materialDateInputRefs = ref<Record<number, HTMLInputElement | null>>({})  // 存储每个物料的日期输入框引用
const purchaseOrderData = ref({
  id: null as number | null,
  contractNo: '', // 合同号
})

const paymentMethods = [
  {value: "0", label: "预付"},
  {value: "1", label: "现付"},
  {value: "2", label: "月结"},
  {value: "3", label: "次月结"},
]

// 将日期字符串转换为时间戳（毫秒）
const dateTimestamp = (dateStr: string) => {
  if (!dateStr) return undefined
  try {
    // dateStr 格式: YYYY-MM-DD
    const date = new Date(dateStr)
    // 设置为当天的开始时间（00:00:00）
    date.setHours(0, 0, 0, 0)
    return date.getTime()
  } catch (error) {
    console.error('日期转换失败:', error)
    return undefined
  }
}

// 计算采购单总金额
const calculatePurchaseTotalAmount = () => {
  const total = selectedMaterialDetails.value.reduce((sum, material) => {
    const quantity = Number(material.materialCount) || 0
    const price = Number(material.materialPrice) || 0
    return sum + (quantity * price)
  }, 0)
  purchaseData.value.totalAmount = Number(total.toFixed(2))
}

// 监听物料详情变化，自动计算总金额
watch(
  selectedMaterialDetails,
  () => {
    calculatePurchaseTotalAmount()
  },
  { deep: true }
)

// 计算单个物料总价
const calculateTotalPrice = (price: number, quantity: number) => {
  if (!price || !quantity) {
    return '0.00'
  }
  const total = Number(price) * Number(quantity)
  return total.toFixed(2)
}

// 处理数量输入，只允许正整数，不允许小数点
const handleQuantityInput = (material: any) => {
  // 获取输入值并转为字符串
  let value = String(material.materialCount || '').trim()
  
  // 严格过滤：只保留数字，移除所有其他字符（包括小数点、负号、字母等）
  value = value.replace(/[^\d]/g, '')
  
  // 如果为空，清空数量
  if (value === '') {
    material.materialCount = ''
    return
  }
  
  // 移除前导零（例如：007 -> 7，但 0 保持为 0）
  value = value.replace(/^0+(\d)/, '$1')
  
  // 转换为正整数
  const num = parseInt(value, 10)
  
  // 只接受大于 0 的正整数
  if (!isNaN(num) && num > 0) {
    material.materialCount = num
  } else {
    // 不接受 0 和负数
    material.materialCount = ''
  }
}

// 处理单价输入，只允许正数，最多两位小数
const handlePriceInput = (material: any) => {
  // 获取输入值
  let value = String(material.materialPrice || '')
  
  // 允许数字和一个小数点
  value = value.replace(/[^\d.]/g, '')
  
  // 如果为空或只有小数点，设置为空字符串
  if (value === '' || value === '.') {
    material.materialPrice = ''
    return
  }
  
  // 确保只有一个小数点
  const parts = value.split('.')
  if (parts.length > 2) {
    value = parts[0] + '.' + parts.slice(1).join('')
  }
  
  // 限制小数点后只有两位
  if (parts.length === 2) {
    if (parts[1].length > 2) {
      value = parts[0] + '.' + parts[1].substring(0, 2)
    }
  }
  
  // 移除整数部分的前导零（但保留小数前的0）
  if (parts[0].length > 1 && parts[0].startsWith('0')) {
    parts[0] = parts[0].replace(/^0+/, '')
    value = parts.length === 2 ? parts[0] + '.' + parts[1].substring(0, 2) : parts[0]
  }
  
  // 转换为数字验证
  const num = parseFloat(value)
  if (!isNaN(num) && num >= 0) {
    material.materialPrice = value
  } else {
    material.materialPrice = ''
  }
}

// 打开请购弹窗
const handleCreatePurchaseOrder = (item: MergedGoodsItem) => {
  // 将当前货品转换为物料详情格式
  purchaseOrderMaterials.value = [{
    id: item.goodsNo,
    materialName: item.goodsName || '',
    materialCode: item.goodsNo || '',
    specDesc: item.goodsSpec || '',
    materialUnit: item.unit || '',
    materialCount: null, // 数量需要用户输入
    brand: '', // 品牌
    remark: item.goodsDesc, // 采购备注
    warehouse: null as any, // 入库仓库
    paymentDate: '', // 计划交货日期
    materialType: '', // 物料类型
    bigClass: '', // 大类
  }]
  purchaseOrderData.value = { id: null, contractNo: '' }
  materialDateInputRefs.value = {}
  showPurchaseOrderDialog.value = true
}

// 关闭请购弹窗
const closePurchaseOrderDialog = () => {
  showPurchaseOrderDialog.value = false
  purchaseOrderMaterials.value = []
  purchaseOrderData.value = { id: null, contractNo: '' }
  materialDateInputRefs.value = {}
  purchaseOrderForm.value?.reset()
}

// 获取今天的日期字符串（用于日期选择器的min属性）
const getTodayDate = () => {
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// 设置物料日期输入框引用
const setMaterialDateInputRef = (el: HTMLInputElement | null, index: number) => {
  if (el) {
    materialDateInputRefs.value[index] = el
  }
}

// 打开物料的日期选择器
const openMaterialDatePicker = (index: number) => {
  const input = materialDateInputRefs.value[index]
  if (input) {
    if (input.showPicker) {
      input.showPicker()
    } else {
      input.click()
    }
  }
}

// 物料日期选择变化处理
const onMaterialDateChange = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement
  const newDate = target.value
  
  try {
    if (newDate && typeof newDate === 'string' && purchaseOrderMaterials.value[index]) {
      purchaseOrderMaterials.value[index].paymentDate = newDate
    }
  } catch (error) {
    console.error('物料日期处理失败:', error)
  }
}

// 处理请购数量输入
// const handlePurchaseOrderQuantityInput = (material: any, index: number) => {
//   let value = String(material.materialCount || '').trim()
//   value = value.replace(/[^\d]/g, '')
  
//   if (value === '') {
//     material.materialCount = ''
//     return
//   }
  
//   value = value.replace(/^0+(\d)/, '$1')
//   const num = parseInt(value, 10)
  
//   if (!isNaN(num) && num > 0) {
//     material.materialCount = num
//   } else {
//     material.materialCount = ''
//   }
// }
const handlePurchaseOrderQuantityInput = (material: any, index: number) => {
  let value = String(material.materialCount || '').trim()
  value = value.replace(/[^\d.]/g, '')

  const dotIndex = value.indexOf('.')
  if (dotIndex !== -1) {
    const beforeDot = value.substring(0, dotIndex)
    const afterDot = value.substring(dotIndex + 1).replace(/\./g, '').substring(0, 4)
    value = beforeDot + '.' + afterDot
  }

  if (value === '' || value === '.') {
    material.materialCount = ''
    return
  }

  // 小数点前自动补0
  if (value.startsWith('.')) {
    value = '0' + value
  }

  value = value.replace(/^0+(\d)/, '$1')
  const num = parseFloat(value)

  if (!isNaN(num) && num >= 0) {
    material.materialCount = value
  } else {
    material.materialCount = ''
  }
}

// 提交请购
const submitPurchaseOrder = async () => {
  // 验证表单
  const { valid } = await purchaseOrderForm.value?.validate() || { valid: false }
  
  // 手动验证每个物料的必填项
  const materials = purchaseOrderMaterials.value
  // for (let i = 0; i < materials.length; i++) {
  //   const material = materials[i]
  //   if (!material.materialCount || material.materialCount <= 0) {
  //     showError(`请输入第${i + 1}个物料的数量`)
  //     return
  //   }
  //   if (!material.warehouse?.warehouseNo) {
  //     showError(`请选择第${i + 1}个物料的入库仓库`)
  //     return
  //   }
  //   if (!material.paymentDate) {
  //     showError(`请选择第${i + 1}个物料的计划交货日期`)
  //     return
  //   }
  // }
  for (let i = 0; i < materials.length; i++) {
    if(!materials[i].warehouse || !materials[i].warehouse.warehouseNo){
      showError('请选择收货仓库')
      return
    }
  }
  const materialList = materials.map(material => ({
    materialCode: material.materialCode,
    materialName: material.materialName,
    materialSpec: material.specDesc,
    brand: material.brand || '',
    quantity: material.materialCount,
    unit: material.materialUnit,
    remark: material.remark || '',
    warehouseNo: material.warehouse?.warehouseNo || '',
    warehouseName: material.warehouse?.warehouseName || '',
    plannedDeliveryDate: material.paymentDate || '',
    // plannedDeliveryDate: dateTimestamp(material.paymentDate || ''),
  }))
  try {
    purchaseOrderLoading.value = true
    
    const submitData = {
      contractNo: purchaseOrderData.value.contractNo || '', // 合同号
      items: materialList,
    }
    const res = await purchaseApi.purchaseRequisitionAdd(submitData)
    if (res?.code === 0) {
      showSuccess(purchaseOrderData.value.id ? '请购单修改成功' : '请购单创建成功')
      closePurchaseOrderDialog()
    } else {
      showError(res?.message || res?.msg || '创建请购单失败')
    }
  } catch (error: any) {
    console.error('创建请购单失败:', error)
    showError(error.message || '创建请购单失败')
  } finally {
    purchaseOrderLoading.value = false
  }
}

// 打开采购弹窗
const handleCreatePurchase = (item: MergedGoodsItem) => {
  // 将当前货品转换为物料详情格式
  selectedMaterialDetails.value = [{
    id: item.goodsNo,
    materialName: item.goodsName || '',
    materialCode: item.goodsNo || '',
    specDesc: item.goodsSpec || '',
    materialUnit: item.unit || '',
    materialCount: null, // 数量需要用户输入
    materialPrice: null, // 单价需要用户输入
    brand: '', // 品牌
    remark: '', // 采购备注
    materialType: '', // 物料类型
    bigClass: '', // 大类
  }]
  
  showPurchaseDialog.value = true
  // 计算初始总金额
  calculatePurchaseTotalAmount()
}

// 关闭采购弹窗
const closePurchaseDialog = () => {
  showPurchaseDialog.value = false
  purchaseData.value = {
    vendor: null,
    quantity: null,
    price: null,
    purchaseOrderNo: null,
    paymentMethod: {value: '0', label: '预付'},
    paymentDate: null,
    id: null,
    totalAmount: 0,
    warehouse: {warehouseNo: '', warehouseName: ''} as any
  }
  vendorSearchText.value = ''
  selectedMaterialDetails.value = []
  purchaseForm.value?.reset()
}

// 加载供应商列表
const loadVendorList = async () => {
  if(vendorSearchText.value === '' || vendorSearchText.value === null){
    return
  }
  try {
    vendorLoading.value = true
    const res = await purchaseApi.vendorList({
      page: 1,
      pageSize: 100,
      name: vendorSearchText.value || ''
    })
    if (res?.code === 0 && res.data) {
      vendorList.value = res.data.records
    }
  } catch (error: any) {
    console.error('加载供应商列表失败:', error)
    showError(error.message || '加载供应商列表失败')
  } finally {
    vendorLoading.value = false
  }
}

// 监听供应商搜索文本变化（防抖）
const vendorSearchDebounce = (() => {
  let timer: number | null = null
  
  return () => {
    if (timer) {
      clearTimeout(timer)
    }
    
    timer = setTimeout(() => {
      loadVendorList()
      timer = null
    }, 300)
  }
})()

// 监听vendorSearchText变化
watch(vendorSearchText, () => {
  if(purchaseData.value.id !== null || vendorSearchText.value === ''){
    return
  }
  vendorSearchDebounce()
})

// 打开原生日期选择器
const nativeDateInput = ref<HTMLInputElement>()
const openNativeDatePicker = () => {
  if (nativeDateInput.value) {
    if (nativeDateInput.value.showPicker) {
      nativeDateInput.value.showPicker()
    } else {
      nativeDateInput.value.click()
    }
  }
}

// 原生 HTML5 日期输入框变化处理
const onNativeDateChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  const newDate = target.value
  
  try {
    if (newDate && typeof newDate === 'string') {
      // HTML5 date 输入框返回的是 YYYY-MM-DD 格式，直接使用
      purchaseData.value.paymentDate = newDate
    } else {
      purchaseData.value.paymentDate = ''
    }
  } catch (error) {
    console.error('日期处理失败:', error)
    purchaseData.value.paymentDate = ''
  }
}

// 提交采购
const submitPurchase = async () => {
  if(!purchaseData.value.vendor) {
    showError('请选择供应商')
    return
  }
  if(!purchaseData.value.paymentDate){
    showError('请选择计划交货时间')
    return
  }
  if(!purchaseData.value.warehouse || !purchaseData.value.warehouse.warehouseNo){
    showError('请选择入库仓库')
    return
  }
  for(let i = 0; i<selectedMaterialDetails.value.length;i++){
    if(selectedMaterialDetails.value[i].materialCount == null || selectedMaterialDetails.value[i].materialCount === '' || selectedMaterialDetails.value[i].materialCount <= 0){
      showError('请输入物料数量')
      return
    }
    if(selectedMaterialDetails.value[i].materialPrice == null || selectedMaterialDetails.value[i].materialPrice === '' || selectedMaterialDetails.value[i].materialPrice <= 0){
      showError('请输入物料单价')
      return
    }
  }
  let tempMaterialList = selectedMaterialDetails.value
  let materialList = []
  for(let i = 0; i<tempMaterialList.length;i++){
    materialList.push({
      materialCode: tempMaterialList[i].materialCode,
      quantity: tempMaterialList[i].materialCount,
      price: tempMaterialList[i].materialPrice,
      remark: tempMaterialList[i].remark,
      brand: tempMaterialList[i].brand,
      materialName: tempMaterialList[i].materialName,
      specDesc: tempMaterialList[i].specDesc,
      materialUnit: tempMaterialList[i].materialUnit,
      materialType: tempMaterialList[i].materialType || '',
      bigClass: tempMaterialList[i].bigClass || '',
    })
  }
  try {
    purchaseLoading.value = true
    const submitData = {
      vendorId: purchaseData.value.vendor?.id,
      warehouseNo: purchaseData.value.warehouse?.warehouseNo,
      warehouseName: purchaseData.value.warehouse?.warehouseName,
      materialList: materialList,
      schDate: dateTimestamp(purchaseData.value.paymentDate),
      paymentType: typeof(purchaseData.value.paymentMethod) === 'string' ? purchaseData.value.paymentMethod : purchaseData.value.paymentMethod.value
    }
    const res = await purchaseApi.purchaseInitiate(submitData)
    if (res?.code === 0) {
      showSuccess(purchaseData.value.id ? '采购单修改成功' : '采购单创建成功')
      closePurchaseDialog()
      // 刷新列表
      loadGoodsList()
    } else {
      showError(res?.message || '创建采购单失败')
    }
  } catch (error: any) {
    console.error('创建采购单失败:', error)
    showError(error.message || '创建采购单失败')
  } finally {
    purchaseLoading.value = false
  }
}

// 表格列配置
const headers = computed(() => {
  // 基础列，始终显示的列
  const baseHeaders = [
    { title: '货品编码', align: 'start', key: 'goodsNo', sortable: false, width: '150px' },
    { title: '货品名称', align: 'start', key: 'goodsName', sortable: false, width: '200px' },
    { title: '规格', align: 'start', key: 'goodsSpec', sortable: false, width: '160px' },
    { title: '物料备注', align: 'start', key: 'goodsDesc', sortable: false, width: '160px' },
    { title: '库存名称', align: 'start', key: 'inventoryName', sortable: false, width: '150px' },
    { title: '仓库', align: 'start', key: 'warehouseName', sortable: false, width: '110px' },
  ]
  
  // 根据时间选择状态添加不同的列
  if (!searchForm.beginDate && !searchForm.endDate) {
    // 没有选择时间，显示待领用、采购中、库存列
    baseHeaders.push(
      { title: ' 料单估算', align: 'end', key: 'materialEstimateQuantity', sortable: false, width: '150px' },
      // { title: '待领用', align: 'end', key: 'pendingQuantity', sortable: false, width: '100px' },
      { title: '采购中', align: 'end', key: 'purchaseQuantity', sortable: false, width: '100px' },
      { title: '库存', align: 'end', key: 'totalInventoryQuantity', sortable: false, width: '100px' }
    )
  } else {
    // 有时间选择，显示期初、入库、出库、期末列
    baseHeaders.push(
      { title: '期初', align: 'end', key: 'totalInitialQuantity', sortable: false, width: '100px' },
      { title: '入库', align: 'end', key: 'totalCurrentInQuantity', sortable: false, width: '100px' },
      { title: '出库', align: 'end', key: 'totalCurrentOutQuantity', sortable: false, width: '100px' },
      { title: '期末', align: 'end', key: 'totalEndQuantity', sortable: false, width: '100px' }
    )
  }
  
  // 添加单位列
  // baseHeaders.push({ title: '单位', align: 'center', key: 'unit', sortable: false, width: '100px' })
  
  // 根据需要添加操作列
  // if (showActions.value) {
    baseHeaders.push({ title: '操作', align: 'center', key: 'actions', sortable: false, width: '100px' })
  // }
  
  return baseHeaders
})

// 格式化数值为两位小数
const formatNumber = (value: number | string | undefined): string => {
  if (value === undefined || value === null || value === '') return '-'
  const num = typeof value === 'string' ? parseFloat(value) : value
  if (isNaN(num) || num === 0) return '-' // 数值为0时也返回'-'

  // // 格式化为两位小数
  // const formatted = num.toFixed(2)
  // // 如果小数部分为.00，则只显示整数部分
  // if (formatted.endsWith('.00')) {
  //   return formatted.slice(0, -3)
  // }

  return num.toString()
}

// 导出数据格式化函数 - 将"-"替换为"0"
const formatExportNumber = (value: number | string | undefined): string => {
  if (value === undefined || value === null || value === '') return '0'
  const num = typeof value === 'string' ? parseFloat(value) : value
  if (isNaN(num) || num === 0) return '0' // 数值为0时返回"0"
  
  // 格式化为两位小数
  const formatted = num.toFixed(2)
  // 如果小数部分为.00，则只显示整数部分
  if (formatted.endsWith('.00')) {
    return formatted.slice(0, -3)
  }
  return formatted
}

// 添加搜索输入追踪
const categorySearchInput = ref('')

// 修改分类列表格式化方法
const formatCategoryList = (categories: CategoryItem[]) => {
  const result: Array<CategoryItem & { displayName: string; level: number }> = []
  const processedIds = new Set<string>()
  
  const shouldIncludeItem = (categoryNo: string) => {
    return !categoryNo.toUpperCase().startsWith('T')
  }
  
  const addToResult = (item: CategoryItem, level: number, parentNames: string[] = []) => {
    if (processedIds.has(item.categoryNo) || !shouldIncludeItem(item.categoryNo)) return
    
    const displayPath = [...parentNames, item.categoryName].join(' / ')
    result.push({
      ...item,
      level,
      displayName: `${displayPath} (${item.categoryNo})`
    })
    processedIds.add(item.categoryNo)
  }
  
  // 处理所有层级的分类
  categories.forEach(category => {
    // 添加一级分类
    addToResult(category, 1)
    
    // 处理二级分类
    if (category.children?.length) {
      category.children.forEach(child => {
        addToResult(child, 2, [category.categoryName])
        
        // 处理三级分类
        if (child.children?.length) {
          child.children.forEach(grandChild => {
            addToResult(grandChild, 3, [category.categoryName, child.categoryName])
          })
        }
      })
    }
  })
  
  // 按编号前2位数字排序
  return result.sort((a, b) => {
    // 获取编号前2位数字
    const getFirstTwoDigits = (code: string) => {
      const match = code.match(/\d{1,2}/)
      return match ? parseInt(match[0]) : 0
    }
    
    const aNum = getFirstTwoDigits(a.categoryNo)
    const bNum = getFirstTwoDigits(b.categoryNo)
    
    // 按前2位数字排序
    if (aNum !== bNum) {
      return aNum - bNum
    }
    
    // 如果前2位数字相同，按完整编号排序
    return a.categoryNo.localeCompare(b.categoryNo)
  })
}

// 分类过滤方法
const filterCategory = (item: any, queryText: string, itemText: string) => {
  if (!queryText?.trim()) return true
  
  const searchText = queryText.trim().toLowerCase()
  const displayText = itemText.toLowerCase()
  const categoryNo = (item.categoryNo || '').toLowerCase()
  
  return displayText.includes(searchText) || categoryNo.includes(searchText)
}

// 格式化仓库名称
const formattedWarehouseList = computed(() => {
  return warehouseList.value.map(warehouse => ({
    ...warehouse,
    warehouseName: `${warehouse.warehouseName}`
  }))
})

// 获取仓库列表
const loadWarehouseList = async () => {
  try {
    const res = await goodsManageApi.getWarehouseList()
    if (res.code === 0) {
      warehouseList.value = res.data || []
    } else {
      warehouseList.value = []
    }
  } catch (error) {
    const err = error as Error
    warehouseList.value = []
  }
}

// 获取分类列表
const loadCategoryList = async () => {
  try {
    const res = await goodsManageApi.getCategoryList()
    if (res.code === 0) {
      // 保存所有分类数据
      categoryList.value = res.data || []
      // 格式化分类列表，添加层级显示
      formattedCategoryList.value = formatCategoryList(categoryList.value)
    } else {
      categoryList.value = []
      formattedCategoryList.value = []
    }
  } catch (error) {
    const err = error as Error
    categoryList.value = []
    formattedCategoryList.value = []
  }
}

// 获取当前日期
const getCurrentDate = () => {
  const date = new Date()
  return formatDate(date, 'YYYY-MM-DD')
}

// 获取当月第一天
const getFirstDayOfMonth = () => {
  const date = new Date()
  date.setDate(1)
  return formatDate(date, 'YYYY-MM-DD')
}

// 初始化日期
const initDates = () => {
  searchForm.beginDate = ''
  searchForm.endDate = ''
}

// 格式化输入框显示的日期
const formatDisplayDate = (dateStr) => {
    if (!dateStr) return ''
    const date = new Date(dateStr)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

// 获取货品列表
const loadGoodsList = async () => {
  loading.value = true
  try {
    // 构建请求参数
    const params: MergedGoodsListQuery = {
      keyword: searchForm.keyword || undefined,
      warehouseNo: searchForm.warehouseNo?.warehouseNo || undefined,
      inventoryNo: searchForm.inventoryNo || undefined,
      inventoryName: searchForm.inventoryName || undefined,
      page: currentPage.value,
      pageSize: pageSize.value
    }

    // 只有当日期字段有值时才将其添加到请求参数中
    if (searchForm.beginDate) {
      params.beginDate = searchForm.beginDate
    }

    if (searchForm.endDate) {
      params.endDate = searchForm.endDate
    }
    
    const res = await inventoryApi.getMergedGoodsList(params)
    
    if (res.code === 0) {
      goodsList.value = (res.data.records || []).map((item: any) => {
        // 尝试从不同字段中获取库存名称
        let inventoryNameValue = item.inventoryName;
        if (!inventoryNameValue && item.categoryName) {
          inventoryNameValue = item.categoryName;
        }
        if (!inventoryNameValue && item.inventoryNo) {
          inventoryNameValue = `编号: ${item.inventoryNo}`;
        }

        // 确保返回的对象包含所有必要字段，即使原始数据中不存在
        return {
          ...item,
          inventoryName: inventoryNameValue || '-', // 如果没有库存名称，使用库存编号
          warehouseInventories: (item.warehouseInventories || []).map((warehouse: any) => ({
            ...warehouse,
            // 确保仓库对象也有完整字段
            warehouseNo: warehouse.warehouseNo || '-',
            warehouseName: warehouse.warehouseName || '-'
          }))
        }
      }) as MergedGoodsItem[]
      
      total.value = res.data.total || 0
      pageSize.value = res.data.size || 10
      currentPage.value = res.data.current || 1
      
      // 数据加载完成后，检查表头可见性
      setTimeout(checkHeaderVisibility, 100)
    } else {
      goodsList.value = []
      total.value = 0
    }
  } catch (error) {
    goodsList.value = []
    total.value = 0
  } finally {
    loading.value = false
  }
}

// 搜索
const handleSearch = () => {
  currentPage.value = 1
  loadGoodsList()
}

// 重置
const handleReset = () => {
  // 重置搜索表单
  searchForm.keyword = ''
  searchForm.warehouseNo = null
  searchForm.inventoryNo = ''
  searchForm.inventoryName = ''
  searchForm.beginDate = ''
  searchForm.endDate = ''
  // 重新加载数据
  currentPage.value = 1
  loadGoodsList()
}

// 原生日期输入框引用
const startDateInput = ref<HTMLInputElement>()
const endDateInput = ref<HTMLInputElement>()

// 打开原生日期选择器
const openStartDatePicker = () => {
    if (startDateInput.value) {
        if (startDateInput.value.showPicker) {
            startDateInput.value.showPicker()
        } else {
            startDateInput.value.click()
        }
    }
}

const openEndDatePicker = () => {
    if (endDateInput.value) {
        if (endDateInput.value.showPicker) {
            endDateInput.value.showPicker()
        } else {
            endDateInput.value.click()
        }
    }
}

// 打开日期选择器
const onDateChange = () => {
    console.log('日期变化:', { startDate: searchForm.beginDate, endDate: searchForm.endDate })
    // currentIndex.value = -1
    searchForm.beginDate = formatDisplayDate(searchForm.beginDate)
    searchForm.endDate = formatDisplayDate(searchForm.endDate)
    // 验证日期范围
    if (searchForm.beginDate && searchForm.endDate) {
        if (searchForm.beginDate > searchForm.endDate) {
            // 如果开始日期大于结束日期，清空结束日期并显示提示
            searchForm.endDate = ''
            showError('开始日期不能大于结束日期')
        }else {
            // getGroupOverview()
        }
    }
}

// 开始日期变化处理
const onStartDateChange = () => {
    searchForm.beginDate = formatDisplayDate(searchForm.beginDate)
    onDateChange()
}

// 结束日期变化处理
const onEndDateChange = () => {
    searchForm.endDate = formatDisplayDate(searchForm.endDate)
    onDateChange()
}

// 处理表格选项变化
const handleOptionsChange = (options: any) => {
  // 如果页码发生变化
  if (options.page !== currentPage.value) {
    currentPage.value = options.page
    loadGoodsList()
  }
  // 如果每页条数发生变化
  if (options.itemsPerPage !== pageSize.value) {
    pageSize.value = options.itemsPerPage
    currentPage.value = 1 // 切换每页条数时重置为第一页
    loadGoodsList()
  }
}

// 监听页码和每页条数变化
watch([currentPage, pageSize], () => {
  loadGoodsList()
})

// 添加编辑方法
const handleEdit = (item: MergedGoodsItem) => {
  // TODO: 实现编辑功能
}

// 自定义过滤方法
const customFilter = (item: any, query: string, itemText: string) => {
  if (!query || !itemText) return true
  
  const queryLower = query.trim().toLowerCase()
  const textLower = itemText.toLowerCase()
  
  // 如果是精确匹配编号，直接返回
  if (item.categoryNo && item.categoryNo.toLowerCase() === queryLower) {
    return true
  }
  
  // 将查询字符串按空格分割，支持多个关键词搜索
  const queryWords = queryLower.split(/\s+/).filter(word => word.length > 0)
  
  // 所有关键词都必须匹配
  return queryWords.every(word => textLower.includes(word))
}

// 计算总页数
const totalPages = computed(() => Math.ceil(total.value / pageSize.value))

// 处理页码变化
const changePage = (page: number) => {
  currentPage.value = page
  window.scrollTo(0, 0)
  loadGoodsList()
}

// 处理每页条数变化
const handlePageSizeChange = (size: number) => {
  pageSize.value = size
  currentPage.value = 1 // 重置到第一页
  window.scrollTo(0, 0)
  loadGoodsList()
}

// 导出相关状态
const exportLoading = ref(false)
const exportResultDialog = ref(false)
const exportResultTitle = ref('')
const exportResultMessage = ref('')

// 导出Excel功能
const exportToExcel = async () => {
  try {
    // 显示加载提示
    exportLoading.value = true
    
    // 获取所有数据
    const allData = await fetchAllData()
    
    // 如果没有数据，提示用户
    if (allData.length === 0) {
      exportLoading.value = false
      exportResultTitle.value = '导出提示'
      exportResultMessage.value = '暂无数据可导出'
      exportResultDialog.value = true
      return
    }
    
    // 构建CSV数据 - 使用当前表头
    const headerRow = headers.value.map(h => h.title).join(',')
    
    // 处理每一行数据
    const dataRows = allData.map(item => {
      // 如果没有仓库信息或仓库为空，创建一行数据
      if (!item.warehouseInventories || item.warehouseInventories.length === 0) {
        // 根据时间选择状态构建行数据
        const row = [
          item.goodsNo || '-',
          item.goodsName || '-',
          item.goodsSpec || '-',
          item.goodsDesc || '-',
          item.inventoryName || '-',
          '-', // 仓库名称
        ]
        
        // 根据时间选择状态添加不同的数据列
        if (!searchForm.beginDate && !searchForm.endDate) {
          // 没有选择时间，添加待领用、采购中、库存列
          row.push(
            // formatExportNumber(item.pendingQuantity),
            formatExportNumber(item.materialEstimateQuantity),
            formatExportNumber(item.purchaseQuantity),
            formatExportNumber(item.totalInventoryQuantity)
          )
        } else {
          // 有时间选择，添加期初、入库、出库、期末列
          row.push(
            formatExportNumber(item.totalInitialQuantity),
            formatExportNumber(item.totalCurrentInQuantity),
            formatExportNumber(item.totalCurrentOutQuantity),
            formatExportNumber(item.totalEndQuantity)
          )
        }
        
        // 添加单位
        row.push(item.unit || '-')
        
        return row.join(',')
      }
      
      // 如果有仓库信息，为每个仓库创建一行
      return item.warehouseInventories.map(warehouse => {
        // 基础列
        const row = [
          item.goodsNo || '-',
          item.goodsName || '-',
          item.goodsSpec || '-',
          item.goodsDesc || '-',
          item.inventoryName || '-',
          warehouse.warehouseNo + ' - ' + warehouse.warehouseName,
        ]
        
        // 根据时间选择状态添加不同的数据列
        if (!searchForm.beginDate && !searchForm.endDate) {
          // 没有选择时间，添加待领用、采购中、库存列
          row.push(
            // formatExportNumber(item.pendingQuantity),
            formatExportNumber(item.materialEstimateQuantity),
            formatExportNumber(item.purchaseQuantity),
            formatExportNumber(warehouse.inventoryQuantity)
          )
        } else {
          // 有时间选择，添加期初、入库、出库、期末列
          row.push(
            formatExportNumber(warehouse.initialQuantity),
            formatExportNumber(warehouse.currentInQuantity),
            formatExportNumber(warehouse.currentOutQuantity),
            formatExportNumber(warehouse.endQuantity)
          )
        }
        
        // 添加单位
        row.push(item.unit || '-')
        
        return row.join(',')
      }).join('\n')
    }).join('\n')
    
    // 合并表头和数据
    const csvContent = `${headerRow}\n${dataRows}`
    
    // 处理中文字符
    const bom = '\uFEFF'
    const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' })
    
    // 创建下载链接
    const downloadLink = document.createElement('a')
    const url = URL.createObjectURL(blob)
    
    // 设置文件名
    let fileName = ''
    
    // 获取当前日期格式化字符串
    const date = new Date()
    const currentDateStr = `${date.getFullYear()}${(date.getMonth()+1).toString().padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}`
    
    // 文件名规则：
    // 1. 有日期区间（期初期末）时：库存管理_期初{beginDate}_期末{endDate}
    // 2. 无日期区间（当前库存）时：库存管理_{当前日期}
    if (searchForm.beginDate && searchForm.endDate) {
      // 处理期初日期格式 - 只保留日期部分，不包含时间
      const beginDate = formatDate(searchForm.beginDate).split(' ')[0].replace(/-/g, '')
      // 处理期末日期格式 - 只保留日期部分，不包含时间
      const endDate = formatDate(searchForm.endDate).split(' ')[0].replace(/-/g, '')
      fileName = `库存管理_期初${beginDate}_期末${endDate}`
    } else {
      // 没有选择日期区间时，使用当前日期
      fileName = `库存管理_${currentDateStr}`
    }
    
    downloadLink.href = url
    downloadLink.download = `${fileName}.csv`
    
    // 触发下载
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
    
    // 释放URL对象
    setTimeout(() => {
      URL.revokeObjectURL(url)
    }, 100)
    
    // 关闭加载提示
    exportLoading.value = false
  } catch (error) {
    console.error('导出Excel失败:', error)
    exportLoading.value = false
    exportResultTitle.value = '导出失败'
    exportResultMessage.value = '导出失败，请重试'
    exportResultDialog.value = true
  }
}

// 获取所有数据的函数
const fetchAllData = async (): Promise<MergedGoodsItem[]> => {
  // 保存当前分页状态，以便导出后恢复
  const currentPageBackup = currentPage.value
  const pageSizeBackup = pageSize.value
  
  try {
    // 构建请求参数
    const params: MergedGoodsListQuery = {
      keyword: searchForm.keyword || undefined,
      warehouseNo: searchForm.warehouseNo || undefined,
      inventoryNo: searchForm.inventoryNo || undefined,
      inventoryName: searchForm.inventoryName || undefined,
      page: 1,
      pageSize: 1000 // 使用较大的页面大小，一次性获取更多数据
    }

    if (searchForm.beginDate) {
      params.beginDate = searchForm.beginDate
    }

    if (searchForm.endDate) {
      params.endDate = searchForm.endDate
    }
    
    // 发起请求
    const res = await inventoryApi.getMergedGoodsList(params)
    
    if (res.code === 0) {
      // 处理返回的数据
      const totalItems = res.data.total
      const totalPages = Math.ceil(totalItems / 1000)
      
      // 如果只有一页，直接返回
      if (totalPages <= 1) {
        return processGoodsData(res.data.records || [])
      }
      
      // 如果有多页，获取所有页面数据
      const allData: any[] = [...(res.data.records || [])]
      
      // 获取剩余页面数据
      for (let page = 2; page <= totalPages; page++) {
        params.page = page
        const pageRes = await inventoryApi.getMergedGoodsList(params)
        if (pageRes.code === 0 && pageRes.data.records) {
          allData.push(...pageRes.data.records)
        }
      }
      
      return processGoodsData(allData)
    } else {
      console.error('获取导出数据失败:', res.msg)
      return []
    }
  } catch (error) {
    console.error('获取导出数据失败:', error)
    return []
  } finally {
    // 恢复原来的分页状态
    currentPage.value = currentPageBackup
    pageSize.value = pageSizeBackup
  }
}

// 处理商品数据，保持与loadGoodsList函数中的处理一致
const processGoodsData = (data: any[]): MergedGoodsItem[] => {
  return data.map((item: any) => {
    // 尝试从不同字段中获取库存名称
    let inventoryNameValue = item.inventoryName
    if (!inventoryNameValue && item.categoryName) {
      inventoryNameValue = item.categoryName
    }
    if (!inventoryNameValue && item.inventoryNo) {
      inventoryNameValue = `编号: ${item.inventoryNo}`
    }

    // 确保返回的对象包含所有必要字段，即使原始数据中不存在
    return {
      ...item,
      inventoryName: inventoryNameValue || '-', // 如果没有库存名称，使用库存编号
      warehouseInventories: (item.warehouseInventories || []).map((warehouse: any) => ({
        ...warehouse,
        // 确保仓库对象也有完整字段
        warehouseNo: warehouse.warehouseNo || '-',
        warehouseName: warehouse.warehouseName || '-'
      }))
    }
  }) as MergedGoodsItem[]
}

// 添加用于处理悬浮标题栏的变量和方法
const showFloatingHeader = ref(false)

// 检查是否显示悬浮标题栏
const checkHeaderVisibility = () => {
  // 获取表格头部元素
  const tableHeader = document.querySelector('.inventory-table:not(.header-only) thead')
  if (!tableHeader) return
  
  // 获取表格头部的位置信息
  const headerRect = tableHeader.getBoundingClientRect()
  
  // 检查表格头部是否在视图之上
  showFloatingHeader.value = headerRect.bottom < 64 // 假设AppBar的高度是64px
  
  // 如果悬浮表头显示，同步列宽
  if (showFloatingHeader.value) {
    syncColumnWidths()
  }
}

// 同步原表头和浮动表头的列宽
const syncColumnWidths = () => {
  const originalColumns = document.querySelectorAll('.inventory-table:not(.header-only) thead th')
  const floatingColumns = document.querySelectorAll('.floating-header .inventory-table thead th')
  
  if (originalColumns.length === floatingColumns.length) {
    for (let i = 0; i < originalColumns.length; i++) {
      const width = (originalColumns[i] as HTMLElement).offsetWidth
      ;(floatingColumns[i] as HTMLElement).style.width = `${width}px`
    }
  }
}

// 监听滚动事件
const handleScroll = () => {
  checkHeaderVisibility()
}

// 监听窗口大小变化
const handleResize = () => {
  checkHeaderVisibility()
  
  // 只有在悬浮表头显示时才需要更新列宽
  if (showFloatingHeader.value) {
    syncColumnWidths()
  }
}

// 组件挂载后设置滚动监听
onMounted(() => {
  // 获取初始数据
  loadWarehouseList()
  loadCategoryList()
  loadGoodsList()
  
  // 设置滚动监听
  window.addEventListener('scroll', handleScroll)
  
  // 设置窗口大小变化监听
  window.addEventListener('resize', handleResize)
  
  // 初始化检查
  setTimeout(checkHeaderVisibility, 500)
})

// 组件销毁前移除监听器
onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
  window.removeEventListener('resize', handleResize)
})

// 添加样式
const style = document.createElement('style')
style.textContent = `
.category-menu .v-list-item {
  min-height: 36px !important;
  padding: 4px 16px !important;
  font-size: 14px !important;
}
.category-menu .v-list {
  padding: 4px 0 !important;
}
`
document.head.appendChild(style)
</script>

<style lang="scss" scoped>
.inventory-page {
  min-height: 100vh;
  width: 100%;
  background-color: #2B2D33;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 16px;
}

.inventory-container {
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.search-card {
  background-color: #2B2D33 !important;
  border: none !important;
  position: relative;
  z-index: 20;

  :deep(.v-text-field),
  :deep(.v-autocomplete),
  :deep(.v-select) {
    .v-field__input,
    .v-field__field,
    input,
    .v-select__selection-text,
    .v-select__selection,
    .v-field__append-inner {
      color: #fff !important;
    }

    .v-field__outline {
      color: rgba(255, 255, 255, 0.12) !important;
    }

    .v-field__input::placeholder {
      color: rgba(255, 255, 255, 0.7) !important;
    }

    .v-label {
      color: rgba(255, 255, 255, 0.7) !important;
    }

    .v-field__append-inner i {
      color: rgba(255, 255, 255, 0.7) !important;
    }
  }
}

.table-card {
  background-color: #2B2D33 !important;
  flex: 1;
  display: flex;
  position: relative;
  z-index: 1;
  :deep(.v-card-text) {
    padding: 16px;
  }

  :deep(.v-col) {
    padding-top: 4px;
    padding-bottom: 4px;
    display: flex;
    justify-content: center;
  }

  .search-btn {
    font-weight: 400;
    text-transform: none;
    letter-spacing: 0;
    font-size: 14px;
    padding: 0 8px;
    min-width: unset;
  }
}

.table-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #2B2D33 !important;
  border-radius: 0;
  
  :deep(.v-card-text) {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

.inventory-table {
  flex: 1;
  background-color: #2B2D33 !important;
  color: #fff !important;
  border-radius: 0;
  position: relative;
  z-index: 1;
  
  :deep(th) {
    color: rgba(255, 255, 255, 0.7) !important;
    font-weight: 400;
    font-size: 14px;
    background-color: #2B2D33 !important;
    border-bottom: thin solid rgba(255, 255, 255, 0.12);
    padding: 0 16px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  :deep(td) {
    padding: 8px 16px !important;
    height: auto;
    min-height: 48px;
    color: #fff !important;
    border-bottom: thin solid rgba(255, 255, 255, 0.12) !important;
    white-space: normal;
    word-wrap: break-word;
    word-break: break-all;
    
    &[data-key="goodsNo"] {
      width: 170px;
      max-width: 170px;
    }
    
    &[data-key="goodsName"] {
      width: 150px;
      max-width: 150px;
    }
    
    &[data-key="goodsSpec"] {
      width: 200px;
      max-width: 200px;
    }
    
    &[data-key="goodsDesc"] {
      width: 100px;
      max-width: 100px;
    }
    
    &[data-key="inventoryNo"] {
      width: 150px;
      max-width: 150px;
    }
    
    &[data-key="inventoryName"] {
      width: 150px;
      max-width: 150px;
    }
    
    &[data-key="warehouseName"] {
      width: 180px;
      max-width: 180px;
    }
    
    &[data-key="inventoryQuantity"] {
      width: 150px;
      max-width: 150px;
    }
    
    &[data-key="unit"] {
      width: 100px;
      max-width: 100px;
    }
    
    &[data-key="actions"] {
      width: 100px;
      max-width: 100px;
      padding: 4px 16px !important;
      
      .action-btn {
        color: #42D392 !important;
        font-size: 14px;
        font-weight: normal;
        letter-spacing: 0;
        text-transform: none;
        padding: 0;
        height: 32px;
        min-width: 40px;
        
        &:hover {
          opacity: 0.8;
          background: transparent !important;
        }
      }
    }
  }
  
  /* 数值类型的单元格右对齐，保持一致，不换行 */
  :deep(td[data-key="pendingQuantity"]),
  :deep(td[data-key="materialEstimateQuantity"]),
  :deep(td[data-key="purchaseQuantity"]),
  :deep(td[data-key="totalInventoryQuantity"]),
  :deep(td[data-key="totalInitialQuantity"]),
  :deep(td[data-key="totalCurrentInQuantity"]),
  :deep(td[data-key="totalCurrentOutQuantity"]),
  :deep(td[data-key="totalEndQuantity"]) {
    text-align: right;
    font-family: "Roboto Mono", monospace;
    font-feature-settings: "tnum";
    letter-spacing: 0.5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  :deep(tr:hover td) {
    background-color: rgba(255, 255, 255, 0.04) !important;
  }
  
  :deep(.main-row) {
    cursor: pointer;
  }
  
  :deep(.warehouse-row) {
    background-color: rgba(33, 35, 40, 0.5) !important;
    
    td {
      background-color: transparent !important;
      color: rgba(255, 255, 255, 0.8) !important;
      height: 42px;
      min-height: 42px;
      font-size: 13px;
      padding-top: 6px !important;
      padding-bottom: 6px !important;
      
      &.font-weight-bold {
        color: #fff !important;
        font-weight: 500;
      }
    }
    
    .warehouse-detail-cell {
      color: rgba(255, 255, 255, 0.7);
      font-size: 13px;
      font-weight: 500;
      opacity: 0.5;
    }
    
    /* 最后一个子行设置完整的底部边框 */
    &:last-child td {
      border-bottom-color: rgba(255, 255, 255, 0.12) !important;
    }
  }
}

.custom-pagination {
  background-color: rgba(255, 255, 255, 0.02);
  color: rgba(255, 255, 255, 0.7);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 16px;
  min-height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.items-per-page-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  user-select: none;
}

.pagination-info {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  user-select: none;
}

.pagination-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  min-width: 60px;
  text-align: center;
  user-select: none;
}

.page-size-select {
  padding: 0 !important;
  
  :deep(.v-field) {
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.1) !important;
    min-height: 32px !important;
    padding: 0 8px !important;
    background: transparent !important;
  }
  
  :deep(.v-field__input) {
    padding: 0 !important;
    min-height: 32px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 14px;
  }
  
  :deep(.v-select__selection) {
    color: rgba(255, 255, 255, 0.7) !important;
    margin: 0;
    padding: 0;
  }
  
  :deep(.v-field__append-inner) {
    padding-inline-start: 0;
    color: rgba(255, 255, 255, 0.7);
  }
  
  :deep(.v-field__outline) {
    display: none;
  }
  
  :deep(.v-input__control) {
    min-height: 32px !important;
    height: 32px !important;
  }
  
  :deep(.v-field--active),
  :deep(.v-field--dirty) {
    border-color: rgba(255, 255, 255, 0.2) !important;
  }
  
  :deep(.v-field--center-affix) .v-field__append-inner {
    align-items: center;
  }
}

/* 分页按钮样式 */
/* .pagination-btn {
  border-radius: 50% !important;
  min-width: 36px !important;
  width: 36px !important;
  height: 36px !important;
  padding: 0 !important;
  margin: 0 4px !important;
  
  &:not(.v-btn--disabled) {
    background: linear-gradient(315deg, #E34C65, #D2475D) !important;
    color: white !important;
    border: none !important;
    box-shadow: 0 2px 8px rgba(227, 76, 101, 0.3) !important;

    &:hover {
      box-shadow: 0 4px 12px rgba(227, 76, 101, 0.4) !important;
    }
    
    &:active {
      box-shadow: 0 1px 4px rgba(227, 76, 101, 0.2) !important;
    }
  }
  
  &.v-btn--disabled {
    opacity: 0.5;
    background: linear-gradient(315deg, rgba(227, 76, 101, 0.5), rgba(255, 123, 142, 0.5)) !important;
    color: rgba(255, 255, 255, 0.5) !important;
    box-shadow: none !important;
  }
} */

:deep(.v-card) {
  box-shadow: none !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

:deep(.date-input) {
  /* max-width: 180px; */
  
  .v-field__append-inner button {
    color: #fff !important;
  }
  
  .v-field__append-inner i {
    color: #fff !important;
    }
  
  .v-date-picker {
    background-color: #2B2D33 !important;
    color: #fff !important;
    
    .v-date-picker-header {
      color: #fff !important;
    }
    
    .v-date-picker-table {
      color: #fff !important;
    }
  }
}

/* 悬浮标题栏样式 */
.floating-header {
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  z-index: 10;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  background-color: #2B2D33;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  transform: translateY(-100%);
  display: flex;
  justify-content: center;
}

.floating-header-container {
  width: 100%;
  max-width: 1400px;
  padding: 0 16px;
}

.floating-header.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.floating-header .inventory-table {
  background-color: #2B2D33 !important;
  margin-bottom: 0;
  width: 100%;
  table-layout: fixed;
}

.floating-header .inventory-table th {
  position: sticky;
  top: 0;
  background-color: #2B2D33 !important;
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 400;
  font-size: 14px;
  border-bottom: thin solid rgba(255, 255, 255, 0.12);
  padding: 0 16px !important;
  height: 48px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 确保表格宽度正确 */
.header-only {
  overflow: hidden;
}

:deep(.mdi-magnify::before){
  color: #fff!important;
}

/* 采购对话框样式 */
.purchase-dialog {
  background-color: #2B2D33 !important;
}

.purchase-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px 24px;
  font-size: 18px;
  font-weight: 500;
}

.purchase-dialog :deep(.v-card-text) {
  padding: 24px;
}

.purchase-dialog :deep(.v-card-actions) {
  padding: 16px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.purchase-dialog :deep(.v-autocomplete .v-field__input),
.purchase-dialog :deep(.v-text-field .v-field__input),
.purchase-dialog :deep(.v-autocomplete input),
.purchase-dialog :deep(.v-text-field input),
.purchase-dialog :deep(.v-textarea .v-field__input),
.purchase-dialog :deep(.v-textarea textarea) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__outline),
.purchase-dialog :deep(.v-text-field .v-field__outline),
.purchase-dialog :deep(.v-textarea .v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__input::placeholder),
.purchase-dialog :deep(.v-text-field .v-field__input::placeholder),
.purchase-dialog :deep(.v-textarea .v-field__input::placeholder) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.purchase-dialog :deep(.v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__append-inner i),
.purchase-dialog :deep(.v-text-field .v-field__append-inner i) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.purchase-dialog :deep(.v-list) {
  background-color: #2B2D33 !important;
}

.purchase-dialog :deep(.v-list-item) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-list-item:hover) {
  background-color: rgba(255, 255, 255, 0.08) !important;
}

.purchase-dialog :deep(.v-list-item-title) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.6) !important;
}

.purchase-dialog :deep(.v-messages__message) {
  color: #ff5252 !important;
}

/* 隐藏数字输入框的箭头 */
.purchase-dialog :deep(input[type="number"])::-webkit-inner-spin-button,
.purchase-dialog :deep(input[type="number"])::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.purchase-dialog :deep(input[type="number"]) {
  -moz-appearance: textfield;
}

.purchase-dialog :deep(.mdi) {
  color: #fff !important;
}

/* 物料采购列表样式 */
.material-purchase-list {
  margin: 20px 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  overflow: hidden;
}

/* 请购表头样式 */
.material-purchase-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background-color: rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.material-purchase-header .header-item {
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  padding: 0 8px;
}

.material-purchase-header .header-item .required-mark {
  color: #ff5252;
  margin-left: 2px;
}

.material-purchase-body {
  max-height: 400px;
  overflow-y: auto;
}

.material-purchase-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  transition: background-color 0.2s;
}

.material-purchase-item:hover {
  background-color: rgba(255, 255, 255, 0.03);
}

.material-purchase-item:last-child {
  border-bottom: none;
}

.material-purchase-item .item-content {
  color: #fff;
  font-size: 14px;
  text-align: center;
  padding: 0 4px;
}

.material-purchase-item .material-name {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
}

.material-purchase-item .material-spec {
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  text-align: left;
  margin-top: 2px;
}

.material-purchase-item .material-code {
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  text-align: left;
  margin-top: 4px;
}

/* 日期选择器字段样式 */
.native-date-field {
  cursor: pointer;
}

/* 只读字段样式 */
:deep(.v-field--readonly) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

:deep(.v-field--readonly .v-field__input) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-primary {
  color: #D2475D !important;
}

:deep(.mdi-calendar::before){
  color: #fff !important;
}
</style> 